var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovingCircleArrowReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3334C14.6025 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6025 1.66669 10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334Z",
    stroke: "#404D5C",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 6.25L12.7628 7.22516C13.2013 7.78565 13.1207 7.95454 12.4145 7.95454H8.00008C6.78213 7.95454 6.66675 8.59375 6.66675 9.65908M8.00008 13.75L7.23729 12.7748C6.79887 12.2143 6.87954 12.0454 7.5857 12.0454H12.0001C13.218 12.0454 13.3334 11.4062 13.3334 10.3409",
    stroke: "#404D5C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingCircleArrowReload);
export default __webpack_public_path__ + "static/media/moving-circle-arrow-reload.11902514d0f11bffe6ad39bbf4e66c1b.svg";
export { ForwardRef as ReactComponent };